'use client';

import { c as _c } from "react/compiler-runtime";
import './honor-card-builder.scss';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Select } from '@sola/ark-core/molecules/select/select.tsx';
import { TextArea } from '@sola/ark-core/molecules/text-area/text-area.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { DesignPalette } from '../../molecules/honor-card-design-palette/honor-card-design-palette.tsx';
import { HonorCard } from '../../molecules/honor-card/honor-card.tsx';
import { ShareButtons } from '../../molecules/share-buttons/share-buttons.tsx';
import { NOTE_CHARS_PER_LINE, NOTE_MAX_CHARS, NOTE_MAX_LINES } from './honor-card-builder.data.ts';
import { useHonorCardBuilder } from './honor-card-builder.logic.ts';
const HonorCardBuilderInner: React.FC = () => {
  const $ = _c(121);
  const {
    coverCategory,
    coverNumber,
    giftId,
    selectedGift,
    personalNote,
    setCoverCategory,
    setCoverNumber,
    setGiftId,
    setPersonalNote,
    coverCategories,
    coverNumbers,
    giftOptions,
    handleDownloadPdf,
    handleEmailCard,
    handleViewCard,
    shareUrl
  } = useHonorCardBuilder();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["honor-card"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("honor-card:title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h1 className="heading-lg heading-neutral-amplified mb-comfy-sm">{t1}</h1>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("honor-card:subtitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="label-moderate label-lg mb-comfy-lg">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("honor-card:cardType");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== setCoverCategory) {
    t6 = e => setCoverCategory(e.target.value);
    $[11] = setCoverCategory;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== coverCategories || $[14] !== coverCategory || $[15] !== t5 || $[16] !== t6) {
    t7 = <Select isFocused={true} items={coverCategories} label={t5} name="cover-category-select" onChange={t6} value={coverCategory} required={true} />;
    $[13] = coverCategories;
    $[14] = coverCategory;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("honor-card:design");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== coverNumber || $[21] !== coverNumbers || $[22] !== setCoverNumber || $[23] !== t8) {
    t9 = <DesignPalette label={t8} value={coverNumber} options={coverNumbers} onChange={setCoverNumber} />;
    $[20] = coverNumber;
    $[21] = coverNumbers;
    $[22] = setCoverNumber;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("honor-card:giftGiven");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== setGiftId) {
    t11 = e_0 => setGiftId(e_0.target.value);
    $[27] = setGiftId;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== giftId || $[30] !== giftOptions || $[31] !== t10 || $[32] !== t11) {
    t12 = <Select isFocused={true} items={giftOptions} label={t10} name="gift-select" onChange={t11} value={giftId} required={true} />;
    $[29] = giftId;
    $[30] = giftOptions;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t) {
    t13 = t("honor-card:personalMessage");
    $[34] = t;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t) {
    t14 = t("honor-card:letterPlaceholder");
    $[36] = t;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== setPersonalNote) {
    t15 = e_1 => setPersonalNote(e_1.target.value);
    $[38] = setPersonalNote;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t) {
    t16 = fillPercent => t("honor-card:messageFull", {
      fillPercent
    });
    $[40] = t;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== personalNote || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16) {
    t17 = <TextArea label={t13} name="personal-note" placeholder={t14} defaultValue={personalNote} onChange={t15} maxLines={NOTE_MAX_LINES} charsPerLine={NOTE_CHARS_PER_LINE} maxLength={NOTE_MAX_CHARS} counterMode="percentage" rows={NOTE_MAX_LINES} renderCapacityLabel={t16} />;
    $[42] = personalNote;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t12 || $[49] !== t17 || $[50] !== t7 || $[51] !== t9) {
    t18 = <div className="flex flex-col mb-comfy-md">{t7}{t9}{t12}{t17}</div>;
    $[48] = t12;
    $[49] = t17;
    $[50] = t7;
    $[51] = t9;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  const t19 = selectedGift?.label;
  const t20 = selectedGift?.message;
  let t21;
  if ($[53] !== coverCategory || $[54] !== coverNumber || $[55] !== personalNote || $[56] !== t19 || $[57] !== t20) {
    t21 = <HonorCard variant="preview" coverCategory={coverCategory} coverNumber={coverNumber} giftLabel={t19} giftMessage={t20} personalNote={personalNote} />;
    $[53] = coverCategory;
    $[54] = coverNumber;
    $[55] = personalNote;
    $[56] = t19;
    $[57] = t20;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== t) {
    t22 = t("honor-card:view");
    $[59] = t;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== handleViewCard || $[62] !== t22) {
    t23 = <ButtonStyle variant="primary" size="lg"><button type="button" onClick={handleViewCard}>{t22}</button></ButtonStyle>;
    $[61] = handleViewCard;
    $[62] = t22;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== t) {
    t24 = t("honor-card:readyToSend");
    $[64] = t;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== t24) {
    t25 = <h2 className="heading-sm heading-neutral-amplified">{t24}</h2>;
    $[66] = t24;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  let t26;
  if ($[68] !== t) {
    t26 = t("honor-card:deliverYourself");
    $[68] = t;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  let t27;
  if ($[70] !== t26) {
    t27 = <h4 className="w-full col-span-full">{t26}</h4>;
    $[70] = t26;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== handleEmailCard || $[73] !== t) {
    t28 = () => handleEmailCard(t("honor-card:shareTitle"), t("honor-card:shareSummary"));
    $[72] = handleEmailCard;
    $[73] = t;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== t) {
    t29 = t("honor-card:email");
    $[75] = t;
    $[76] = t29;
  } else {
    t29 = $[76];
  }
  let t30;
  if ($[77] !== t29) {
    t30 = <ArkIcon iconName="mail-01" alt={t29} />;
    $[77] = t29;
    $[78] = t30;
  } else {
    t30 = $[78];
  }
  let t31;
  if ($[79] !== t) {
    t31 = t("honor-card:email");
    $[79] = t;
    $[80] = t31;
  } else {
    t31 = $[80];
  }
  let t32;
  if ($[81] !== t28 || $[82] !== t30 || $[83] !== t31) {
    t32 = <ButtonStyle variant="primary" size="lg"><button type="button" onClick={t28}>{t30}{t31}</button></ButtonStyle>;
    $[81] = t28;
    $[82] = t30;
    $[83] = t31;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  let t33;
  if ($[85] !== t) {
    t33 = t("honor-card:shareTitle");
    $[85] = t;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== t) {
    t34 = t("honor-card:shareSummary");
    $[87] = t;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  let t35;
  if ($[89] !== t) {
    t35 = t("honor-card:shareOnline");
    $[89] = t;
    $[90] = t35;
  } else {
    t35 = $[90];
  }
  let t36;
  if ($[91] !== shareUrl || $[92] !== t33 || $[93] !== t34 || $[94] !== t35) {
    t36 = <ShareButtons shareUrl={shareUrl} shareTitle={t33} shareSummary={t34} buttonLabel={t35} size="lg" />;
    $[91] = shareUrl;
    $[92] = t33;
    $[93] = t34;
    $[94] = t35;
    $[95] = t36;
  } else {
    t36 = $[95];
  }
  let t37;
  if ($[96] !== t) {
    t37 = t("honor-card:print");
    $[96] = t;
    $[97] = t37;
  } else {
    t37 = $[97];
  }
  let t38;
  if ($[98] !== t37) {
    t38 = <ArkIcon iconName="book-open-01" alt={t37} />;
    $[98] = t37;
    $[99] = t38;
  } else {
    t38 = $[99];
  }
  let t39;
  if ($[100] !== t) {
    t39 = t("honor-card:print");
    $[100] = t;
    $[101] = t39;
  } else {
    t39 = $[101];
  }
  let t40;
  if ($[102] !== handleDownloadPdf || $[103] !== t38 || $[104] !== t39) {
    t40 = <ButtonStyle variant="secondary" size="lg"><button type="button" onClick={handleDownloadPdf}>{t38}{t39}</button></ButtonStyle>;
    $[102] = handleDownloadPdf;
    $[103] = t38;
    $[104] = t39;
    $[105] = t40;
  } else {
    t40 = $[105];
  }
  let t41;
  if ($[106] !== t27 || $[107] !== t32 || $[108] !== t36 || $[109] !== t40) {
    t41 = <div className="flex flex-wrap gap-snug-lg">{t27}{t32}{t36}{t40}</div>;
    $[106] = t27;
    $[107] = t32;
    $[108] = t36;
    $[109] = t40;
    $[110] = t41;
  } else {
    t41 = $[110];
  }
  let t42;
  if ($[111] !== t23 || $[112] !== t25 || $[113] !== t41) {
    t42 = <div className="flex flex-col gap-comfy-md mt-snug-lg">{t23}{t25}{t41}</div>;
    $[111] = t23;
    $[112] = t25;
    $[113] = t41;
    $[114] = t42;
  } else {
    t42 = $[114];
  }
  let t43;
  if ($[115] !== t18 || $[116] !== t2 || $[117] !== t21 || $[118] !== t4 || $[119] !== t42) {
    t43 = <section className="HonorCardBuilder">{t2}{t4}{t18}{t21}{t42}</section>;
    $[115] = t18;
    $[116] = t2;
    $[117] = t21;
    $[118] = t4;
    $[119] = t42;
    $[120] = t43;
  } else {
    t43 = $[120];
  }
  return t43;
};
export const HonorCardBuilder: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense><HonorCardBuilderInner /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};